import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import "./i18n/config";

// Set initial dir based on stored language
const storedLang = localStorage.getItem('i18nextLng') || navigator.language;
if (storedLang === 'ar' || storedLang.startsWith('ar-')) {
  document.documentElement.dir = 'rtl';
  document.documentElement.lang = 'ar';
}

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
